/** Pure helpers for master detail View → Edit — plan/40. */

export type DetailMode = "view" | "edit";

export const DETAIL_COMPACT_MQ = "(max-width: 767px)";

export const NO_PERMISSION_EDIT = "No permission to edit";

/** True when any draft key differs from the server snapshot (same key set). */
export function isDetailDraftDirty(
  draft: Readonly<Record<string, string | boolean | null>>,
  server: Readonly<Record<string, string | boolean | null>>,
): boolean {
  const keys = new Set([...Object.keys(draft), ...Object.keys(server)]);
  for (const key of keys) {
    if ((draft[key] ?? null) !== (server[key] ?? null)) return true;
  }
  return false;
}

/** Tab / document title while dirty in Edit. */
export function detailUnsavedTitle(objectLabel: string): string {
  const base = objectLabel.trim() || "Untitled";
  return `Unsaved · ${base}`;
}

export function discardChangesConfirm() {
  return {
    title: "Discard changes?",
    description: "Your edits will be lost.",
    confirmLabel: "Discard",
    cancelLabel: "Keep editing",
    destructive: true as const,
  };
}
